import React from "react";
import { IStandardTableActionsProps } from "./StandardTableActions.types";
import {
  Box,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentPasteSearchOutlinedIcon from "@mui/icons-material/ContentPasteSearchOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { ContextMenu } from "../ContextMenu/ContextMenu";
import {
  ContactMailOutlined,
  ContentCopyOutlined,
  Delete,
  Download,
  Email,
  SettingsBackupRestore,
} from "@mui/icons-material";

import { Dialog } from "../Dialogs/Dialog";
import { CommentsSideBar } from "../CommentsSideBar/CommentsSideBar";
import { HistorySideBar } from "../HistorySideBar/HistorySideBar";
import { ChangeHistoryTimeline } from "../ChangeHistoryTimeline";
import PersonIcon from "@mui/icons-material/Person";
import { ActivityEmailConversationLogsRightPanel } from "../Activity/ActivityEmailConversationLogsRightPanel";

export const StandardTableActions: React.FC<IStandardTableActionsProps> = (
  props
) => {
  const {
    onViewClick,
    onEditClick,
    onDownLoadClick,
    onDownloadPreview,
    onDuplicateClick,
    onDeleteClick,
    onRestoreClick,
    onEmailClick,
    onAssignedTo,
    downloadLoading,
    more,
    commentBoxTypeId,
    historyCompData,
    changeHistoryCompData,
    otherActions,
    customComponentActions,
    emailLogs
  } = props;

  const [openEmailLogPanel, setOpenEmailLogPanel] = React.useState(false);

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"center"}
        sx={{
          svg: {
            cursor: "pointer",
          },
        }}
        spacing={{
          md: 1,
          lg: 1.8,
          xl: 2,
        }}
      >
        {historyCompData && (
          <HistorySideBar module_code={historyCompData.module_code} />
        )}

        {changeHistoryCompData && (
          <ChangeHistoryTimeline
            module_name={changeHistoryCompData.module_name}
            entry_id={changeHistoryCompData.entry_id}
          />
        )}

        {commentBoxTypeId && <CommentsSideBar typeId={commentBoxTypeId} />}

        {onViewClick && (
          <Box onClick={onViewClick}>
            <Tooltip title="View">
              <VisibilityIcon color="primary" />
            </Tooltip>
          </Box>
        )}
        {onEditClick && (
          <Box onClick={onEditClick}>
            <Tooltip title="Edit">
              <EditIcon color="primary" />
            </Tooltip>
          </Box>
        )}
        {onAssignedTo && (
          <Box onClick={onAssignedTo}>
            <Tooltip title="Assign To">
              <PersonIcon color="primary" />
            </Tooltip>
          </Box>
        )}
        {onEmailClick && (
          <Box onClick={onEmailClick}>
            <Tooltip title="Email">
              <Email color="primary" />
            </Tooltip>
          </Box>
        )}
        {onDuplicateClick && (
          <Box onClick={onDuplicateClick}>
            <Tooltip title="Duplicate">
              <ContentCopyOutlined color="primary" />
            </Tooltip>
          </Box>
        )}
        {onDownloadPreview && (
          <Box onClick={onDownloadPreview}>
            <Tooltip title="Preview">
              <ContentPasteSearchOutlinedIcon color="primary" />
            </Tooltip>
          </Box>
        )}
        {onDownLoadClick && (
          <Box onClick={!downloadLoading ? onDownLoadClick : undefined}>
            <Tooltip title="Download">
              <Download color="primary" />
            </Tooltip>
          </Box>
        )}
        {onDeleteClick && (
          <Box onClick={onDeleteClick}>
            <Tooltip title="Delete">
              <Delete color="primary" />
            </Tooltip>
          </Box>
        )}
        {onRestoreClick && (
          <Box onClick={onRestoreClick}>
            <Tooltip title="Restore">
              <SettingsBackupRestore color="primary" />
            </Tooltip>
          </Box>
        )}

        {emailLogs && (
          <Box onClick={() => setOpenEmailLogPanel(true)}>
            <Tooltip title="Email Logs">
              <ContactMailOutlined color="primary" />
            </Tooltip>
          </Box>
        )

        }

        {otherActions &&
          otherActions.filter(x => !x.hide).map((action, index) => (
            <Box key={index} onClick={action.onClick}>
              <Tooltip title={action.tooltip}>
                <action.icon color="primary" />
              </Tooltip>
            </Box>
          ))}

          {customComponentActions &&
          customComponentActions.map((action, index) => (
            <Box key={index}>
              {action.component}
            </Box>
          ))} 

          

        {more && <ContextMenu menuOptions={more.menuItems}></ContextMenu>}
      </Stack>
      {downloadLoading && (
        <Dialog
          open={downloadLoading || false}
          size="sm"
          onClose={() => {}}
          title=""
        >
          <Stack
            minHeight={"200px"}
            justifyContent={"center"}
            direction={"column"}
            alignItems={"center"}
          >
            <CircularProgress size={40} />
            <Typography variant="h3" marginTop={2}>
              Download in progress..
            </Typography>
          </Stack>
        </Dialog>
      )}

      {emailLogs && openEmailLogPanel && (
        <ActivityEmailConversationLogsRightPanel
          moduleInformation={emailLogs}
          open={openEmailLogPanel}
          onClose={() => setOpenEmailLogPanel(false)}
        />
      )

      }
    </>
  );
};
